import React, { useEffect } from 'react'
import { useGtm, useRegistrant, useSeasonOrganization } from '@/hooks'

// reproduce old logic from App.tsx
const GTMAuthorize: React.FC = () => {
  const { seasonOrganization } = useSeasonOrganization()
  const { registrant } = useRegistrant()
  const { sendDataToGTM } = useGtm()

  useEffect(() => {
    if (!registrant || !seasonOrganization) {
      return
    }

    const userId = `${seasonOrganization.season?.name}_${seasonOrganization.organization.midasId}_${registrant.user.phone}`
    sendDataToGTM({ user_id: userId })
  }, [registrant, seasonOrganization])

  return null
}

export default GTMAuthorize
